/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useTarimas = () => {
  const token = localStorage.getItem("@Token");
  const [tarimas, setTarimas] = useState([]);

  const getTarimas = async () => {
    try {
      const response = await api.get("api/empaque/tarimas/?all=false", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      });
      setTarimas(response.data);
    } catch (error) {
      setTarimas([]);
      console.log(error);
    }
  };

  useEffect(() => {
    getTarimas();
  }, []);

  return { tarimas };
};
